import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import sms from './modules/sms'
import interviewState from './modules/interviewState'

//vuex运行在内存中，当页面刷新（比如location.reload）或关闭时，资源被释放，其次vuex是响应式的
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    sms,
    interviewState
  },
  getters
})

if (store.state.sms.sendSmsCodeTimer > 0) store.dispatch('sms/startCountThread')

export default store
